import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import {
  withNumberingColumn,
  sortStrings,
  dateFormat,
  sortDates,
  dateTimeFormat,
  parseBackendUtcDate,
} from "utils/utils";
import dayjs from "dayjs";

export const KkGroupsAndContractsTable = ({ data, type }) => {
  const [pagination, setPagination] = useState(null);
  const [paginationContracts, setPaginationContracts] = useState(null);
  const [paginationCompleted, setPaginationCompleted] = useState(null);
  const [paginationProspectWithoutTrial, setPaginationProspectWithoutTrial] = useState(null);
  const [paginationProspectFollowUp, setPaginationProspectFollowUp] = useState(null);
  const [paginationProspectInTrial, setPaginationProspectInTrial] = useState(null);
  const [paginationToCancel, setPaginationToCancel] = useState(null);
  const [paginationBdayStudent, setPaginationBdaySudent] = useState(null);
  const [paginationBdayParent, setPaginationBdayParent] = useState(null);

  const handleColumnSelection = () => {
    switch (type) {
      case "group":
        return withNumberingColumn(columnsGroups, pagination);
      case "contract":
        return withNumberingColumn(columnsContracts, paginationContracts);
      case "to_cancel_students":
        return withNumberingColumn(columnsToCancel, paginationToCancel);
      case "prospect_without_trial":
        return withNumberingColumn(columnsToCancel, paginationProspectWithoutTrial);
      case "prospect_follow_up":
        return withNumberingColumn(columnskkProspect, paginationProspectFollowUp);
      case "prospect_in_trial":
        return withNumberingColumn(columnskkProspect, paginationProspectInTrial);
      case "completed":
        return withNumberingColumn(columnsContracts, paginationCompleted);
      case "bdayStudent":
        return withNumberingColumn(columnsBdayStudent, paginationBdayStudent);
      case "bdayParent":
        return withNumberingColumn(columnsBdayParent, paginationBdayParent);
    }
  };

  const handlePaginationChange = (pagination) => {
    switch (type) {
      case "group":
        return setPagination(pagination);
      case "contract":
        return setPaginationContracts(pagination);
      case "to_cancel_students":
        return setPaginationToCancel(pagination);
      case "completed":
        return setPaginationCompleted(pagination);
      case "prospect_without_trial":
        return setPaginationProspectWithoutTrial(pagination);
      case "prospect_follow_up":
        return setPaginationProspectFollowUp(pagination);
      case "prospect_in_trial":
        return setPaginationProspectInTrial(pagination);
      case "bdayStudent":
        return setPaginationBdaySudent(pagination);
      case "bdayParent":
        return setPaginationBdayParent(pagination);
    }
  };

  const columnsGroups = [
    {
      title: "Course title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => sortStrings(a, b, "title"),
      render: (text, { id }) => {
        return <Link to={`/dashboard/klingKlong/group/${id}`}>{text}</Link>;
      },
    },
    {
      title: "Course level",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => sortStrings(a, b, "type"),
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Teacher",
      dataIndex: "teacher",
      key: "teacher",
      sorter: (a, b) =>
        a.teacher?.title && b.teacher?.title ? a.teacher?.title?.localeCompare(b.teacher?.title) : null,
      render: (teacher) => <span>{teacher?.title}</span>,
    },
    {
      title: "Number of children",
      dataIndex: "students",
      key: "students",
      sorter: (a, b) => {
        let studentsA = a.students?.toString();
        let studentsB = b.students?.toString();
        if (studentsA && studentsB) {
          return studentsA?.localeCompare(studentsB, undefined, { numeric: true });
        }
      },
      render: (students) => <span>{students}</span>,
    },
  ];

  const columnsContracts = [
    {
      title: "Student Name",
      dataIndex: "students",
      key: "students",
      sorter: (a, b) =>
        a.students?.fullname && b.students?.fullname ? a.students?.fullname?.localeCompare(b.students?.fullname) : null,
      render: (students) => <span>{students?.fullname}</span>,
    },
    {
      title: "Parent Name",
      dataIndex: "students",
      key: "students",
      sorter: (a, b) =>
        a.students?.parent?.fullname && b.students?.parent?.fullname
          ? a.students?.parent?.fullname?.localeCompare(b.students?.parent?.fullname)
          : null,
      render: (students) => {
        return <Link to={`/dashboard/klingKlong/parent/${students?.parent?.id}`}>{students?.parent?.fullname}</Link>;
      },
    },
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
      sorter: (a, b) => (a.course?.title && b.course?.title ? a.course?.title?.localeCompare(b.course?.title) : null),
      render: (course) => {
        return <Link to={`/dashboard/klingKlong/group/${course?.id}`}>{course?.title}</Link>;
      },
    },
  ];

  const columnsToCancel = [
    {
      title: "Student Name",
      dataIndex: "fullname",
      key: "fullname",
      sorter: (a, b) => (a?.fullname && b?.fullname ? a?.fullname?.localeCompare(b?.fullname) : null),
      render: (fullname) => <span>{fullname}</span>,
    },
    {
      title: "Parent Name",
      dataIndex: "parent",
      key: "parent",
      sorter: (a, b) =>
        a?.parent?.fullname && b?.parent?.fullname ? a?.parent?.fullname?.localeCompare(b?.parent?.fullname) : null,
      render: (parent) => {
        return <Link to={`/dashboard/klingKlong/parent/${parent?.id}`}>{parent?.fullname}</Link>;
      },
    },
  ];

  const columnskkProspect = [
    {
      title: "Student Name",
      dataIndex: "fullname",
      key: "fullname",
      sorter: (a, b) => (a?.fullname && b?.fullname ? a?.fullname?.localeCompare(b?.fullname) : null),
      render: (fullname) => <span>{fullname}</span>,
    },
    {
      title: "Parent Name",
      dataIndex: "parent",
      key: "parent",
      sorter: (a, b) =>
        a?.parent?.fullname && b?.parent?.fullname ? a?.parent?.fullname?.localeCompare(b?.parent?.fullname) : null,
      render: (parent) => {
        return <Link to={`/dashboard/klingKlong/parent/${parent?.id}`}>{parent?.fullname}</Link>;
      },
    },
    {
      title: "Teacher",
      dataIndex: "teacher_fullname",
      key: "teacher_fullname",
      sorter: (a, b) =>
        a.teacher_fullname && b.teacher_fullname ? a.teacher_fullname.localeCompare(b.teacher_fullname) : null,
      render: (teacher_fullname) => <span>{teacher_fullname ? teacher_fullname : "-"}</span>,
    },

    {
      title: "Lesson date",
      dataIndex: "lesson_date",
      key: "lesson_date",
      sorter: (a, b) => sortDates(a, b, "lesson_date"),
      render: (lesson_date) => {
        if (lesson_date) {
          return dayjs(lesson_date).format(dateTimeFormat);
        } else {
          return "-";
        }
      },
    },
  ];

  const columnsBdayStudent = [
    {
      title: "Student Name",
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => (a.first_name && b.first_name ? a.first_name?.localeCompare(b.first_name) : null),
      render: (first_name, student) => (
        <span>
          {first_name} {student?.last_name}
        </span>
      ),
    },
    {
      title: "Parent Name",
      dataIndex: "parent",
      key: "parent",
      sorter: (a, b) =>
        a.parent?.fullname && b.parent?.fullname ? a.parent?.fullname?.localeCompare(b.parent?.fullname) : null,
      render: (parent) => {
        return <Link to={`/dashboard/klingKlong/parent/${parent?.id}`}>{parent?.fullname}</Link>;
      },
    },
    {
      title: " Birthday",
      dataIndex: "full_dob",
      key: "full_dob",
      sorter: (a, b) => sortDates(a, b, "full_dob"),
      render: (full_dob) => {
        return parseBackendUtcDate(full_dob)?.format(dateFormat) ?? "-";
      },
    },
  ];

  const columnsBdayParent = [
    {
      title: "Parent Name",
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => (a.first_name && b.first_name ? a.first_name?.localeCompare(b.first_name) : null),
      render: (first_name, parent) => (
        <Link to={`/dashboard/klingKlong/parent/${parent?.profileId}`}>
          {first_name} {parent?.last_name}
        </Link>
      ),
    },
    {
      title: "Students",
      dataIndex: "students",
      key: "students",
      render: (students) => {
        return students?.map((student) => {
          return `${student.first_name} ${student.last_name}, `;
        });
      },
    },
    {
      title: " Birthday",
      dataIndex: "full_dob",
      key: "full_dob",
      sorter: (a, b) => sortDates(a, b, "full_dob"),
      render: (full_dob) => {
        return parseBackendUtcDate(full_dob)?.format(dateFormat) ?? "-";
      },
    },
  ];

  return (
    <>
      <Table
        bordered
        rowKey="_key"
        columns={handleColumnSelection()}
        dataSource={data?.map((row, i) => ({ ...row, _key: i }))}
        onChange={(pagination) => {
          handlePaginationChange(pagination);
        }}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
      />
    </>
  );
};

export default KkGroupsAndContractsTable;
